import { render, staticRenderFns } from "./Add_admin.vue?vue&type=template&id=144b936d&scoped=true"
import script from "./Add_admin.vue?vue&type=script&lang=js"
export * from "./Add_admin.vue?vue&type=script&lang=js"
import style0 from "./Add_admin.vue?vue&type=style&index=0&id=144b936d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144b936d",
  null
  
)

export default component.exports